import {
    Modal,
    ModalOverlay,
    ModalContent,
    Stack,
    Text,
    Button,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";

export default function SuccessModal({ isOpen, onClose }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered="true">
            <ModalOverlay />
            <ModalContent
                mx={["5vw", "5vw", "0px"]}
                px="30px"
                py="25px"
                borderRadius="15px"
            >
                <Stack gap="24px">
                    <Stack alignItems="center">
                        <CheckIcon w="34px" h="25px" color="#5ED35C" />
                        <Stack gap="8px" textAlign="center">
                            <Text mb={0} fontWeight={700} fontSize="28px">
                                Success!
                            </Text>
                            <Text mb={0} fontWeight={600} fontSize="18px">
                                Your Salesheet is on it's way to your email
                                inbox.
                            </Text>
                            <Text mb={0}>
                                If you don’t see it, be sure to check your spam
                                folder
                            </Text>
                        </Stack>
                    </Stack>
                    <Button
                        w="full"
                        backgroundColor="#DB0025"
                        color="white"
                        letterSpacing="1px"
                        fontSize="12px"
                        onClick={onClose}
                        textTransform="uppercase"
                        borderRadius="12px"
                    >
                        Close
                    </Button>
                </Stack>
            </ModalContent>
        </Modal>
    );
}
